import { legoInit, lego } from '@zz-common/lego'
import { getPageType } from '@/lib/util'
import Vue from 'vue'
import debounce from 'lodash/debounce'
import URL from '@/lib/url'
// import pageIdConfig from './pageId.config'
import pageIdConfig, { useRouteParams } from './pageIdConfig.ts'
import VARS from '@/lib/vars'
import Cookies from 'js-cookie'

const isEmpty = (obj) => !Object.keys(obj).length
let client = window.native.client
if (client === 'm' && /weibo/i.test(navigator.userAgent)) client = 'weibo'

export function legoInitWrap() {
  const routParams = useRouteParams()
  legoInit(
    Object.assign({ stayUserTime: process.env.NODE_ENV === 'production', forbidLegoInPrerender: true, setCloseMark: true, autoAreaExpose: false, autoOcd: true }, pageIdConfig, {
      t: URL.getParam('__t') || URL.getParam('t') || Cookies.get('t'), // t值上报，个业务根据情况自行处理
      // 这一步才是初始化channel参数
      channel:
        (location.href.indexOf('/cashOutDetail') > -1 && URL.getParam('bmChannel')) || // 以旧折现页需要带上这个来源。因为当前版本lego的setUserBackup方法点击埋点不生效，所以先在这里配置
        URL.getParam('channel') ||
        URL.getParam('channelid') ||
        Cookies.get('h5checkin_channel') ||
        VARS.channel, // channel处理，个业务根据情况自行处理
      fromChannel: URL.getParam('fromChannel') || '',
      ...routParams // 增加额外的backup字段
    })
  )
}

/**
 * 通用日志记录器
 * 该方法会自动截取当前路由query上的channel字段
 * pagetype将由上游组件 PAGE_LOG_PREFIX provide提供
 * backup字段将整合上游的PAGE_LOG_BACKUP prvodie提供，用于共享通用backup字段
 * @author wangsongyan@zhuanzhuan.com
 * @anotherdate 2019-09-03T11:11:24+0800
 * @param       {string}                 type   actiontype
 * @param       {backup}                 backup backup字段
 * @return      {undefined}                        无返回值
 */
Vue.prototype.$log = function (type, backup) {
  const { channel } = URL.getQueryObject()
  setTimeout(() => {
    const { PAGE_LOG_PREFIX, LOG_PREFIX, PAGE_LOG_BACKUP, LOG_BACKUP } = this
    const DEF_PAGE_TYPE = getPageType()
    // console.log({
    //     actiontype: type,
    //     pagetype: `${LOG_PREFIX || PAGE_LOG_PREFIX || DEF_PAGE_TYPE}`,
    //     backup: Object.assign({from: client, channel}, isEmpty(LOG_BACKUP || {}) ? PAGE_LOG_BACKUP:LOG_BACKUP, backup)
    // })
    lego.send({
      actiontype: type,
      pagetype: `${LOG_PREFIX || PAGE_LOG_PREFIX || DEF_PAGE_TYPE}`,
      backup: Object.assign(
        { from: client, channel },
        isEmpty(LOG_BACKUP || {}) ? PAGE_LOG_BACKUP : LOG_BACKUP,
        backup
      )
    })
  })
}

// 这里用了一个mixin用于收集通用的日志信息
Vue.mixin({
  inject: {
    LOG_PREFIX: {
      from: 'PAGE_LOG_PREFIX',
      default: ''
    },
    LOG_BACKUP: {
      from: 'PAGE_LOG_BACKUP',
      default: {}
    }
  }
})

const documentClientHeight = document.documentElement.clientHeight || window.innerHeight
const isVisible = (el) => {
  // 元素顶端到可见区域（网页）顶端的距离
  const htmlElementClientTop = el.getBoundingClientRect().top
  // 网页指定元素进入可视区域
  return documentClientHeight >= htmlElementClientTop
}

// 展现埋点监控队列
let listenQueue = []

/**
 * 展现埋点函数，当元素第一次出现在可视区时发送埋点
 * @author wangsongyan@zhuanzhuan.com
 * @anotherdate 2019-09-03T11:22:07+0800
 * @param       {htmlElement}                 el   要监听的元素
 * @param       {...*}              argv 参照$log方法
 * @return      {undefined}                      无返回
 */
Vue.prototype.$exposureLog = function (el, ...argv) {
  const cb = () => this.$log(...argv)
  isVisible(el) ? cb() : listenQueue.push({ el, cb })
}

window.addEventListener(
  'scroll',
  debounce(() => {
    listenQueue = listenQueue.filter(({ el, cb }) => {
      if (isVisible(el)) cb()
      else return true
    })
  }, 1000)
)
